"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.join");

require("core-js/modules/es.array.map");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.string.trim");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _typeValidation = _interopRequireDefault(require("./typeValidation"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var PctyGridHeaderRow = function PctyGridHeaderRow(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      automationId = _ref.automationId,
      __TYPE = _ref.__TYPE,
      other = (0, _objectWithoutProperties2.default)(_ref, ["children", "disabled", "automationId", "__TYPE"]);

  var getAutomation = function getAutomation(suffix) {
    return !automationId ? {} : {
      'data-automation-id': automationId + (suffix ? "-".concat(suffix) : '')
    };
  };

  var _props = _objectSpread(_objectSpread(_objectSpread({}, other), getAutomation()), {}, {
    className: [other.className || '', disabled ? 'pcty-disabled' : ''].join(' ').trim()
  }); // Propagate disabled property to children


  var _children = _react.default.Children.toArray(children).map(function (child) {
    return /*#__PURE__*/_react.default.cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
      __disabled: disabled
    }));
  });

  return /*#__PURE__*/_react.default.createElement("tr", (0, _extends2.default)({
    className: "pcty-grid-header-row-tr"
  }, _props), _children);
};

PctyGridHeaderRow.propTypes = {
  /** Each cell within the header row */
  children: _propTypes.default.node.isRequired,

  /** A string that can be referenced by UI automation tools */
  automationId: _propTypes.default.string,

  /** Whether or not the component is disabled */
  disabled: _propTypes.default.bool,
  __TYPE: function __TYPE(props, propName, componentName) {
    return (0, _typeValidation.default)(props, propName, componentName, 'PctyGridHeaderRow');
  }
  /** INCLUDE OTHER */

};
PctyGridHeaderRow.defaultProps = {
  disabled: false,
  __TYPE: 'PctyGridHeaderRow'
};
var _default = PctyGridHeaderRow;
exports.default = _default;